// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const medicham_mega: PokeData = {
  "id": 10054,
  "name": "medicham-mega",
  "height": 13,
  "weight": 315,
  "base_experience": 179,
  "types": [
    PokeType.FIGHTING,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "fire-punch",
    "ice-punch",
    "thunder-punch",
    "counter",
    "confusion",
    "meditate",
    "recover",
    "bide",
    "high-jump-kick",
    "mind-reader",
    "reversal",
    "detect",
    "endure",
    "hidden-power",
    "psych-up",
    "calm-mind",
    "feint",
    "acupressure",
    "power-trick",
    "force-palm",
    "zen-headbutt"
  ],
  "moves": [
    "fire-punch",
    "ice-punch",
    "thunder-punch",
    "calm-mind",
    "zen-headbutt",
    "double-kick",
    "drain-punch",
    "reflect",
    "rolling-kick",
    "synchronize",
    "psychic",
    "psy-ball",
    "psychic-fangs"
  ],
  "evolution_chain": {
    "id": 152,
    "item": null,
    "species": [
      {
        "name": "meditite",
        "order": 333,
        "types": [
          PokeType.FIGHTING,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "medicham",
        "order": 334,
        "types": [
          PokeType.FIGHTING,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 307,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 37,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 106,
    "speed": 147,
    "ability_power": 147
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
